export function isValidSyntax(vat) {
  return vat.length >= 10;
}

export function isGerman(vat) {
  return vat.slice(0, 2) === "DE";
}
